import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'presetExtractName'
})
export class PresetExtractNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return '';
    }

    return value.replace('var(--design-', '').replace(')', '');
  }
}
